import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'

import * as styles from '@twistopayments/design-system/styles'

export const content = (theme: Theme) => css`
  margin: 0;
  position: absolute;
  right: 0;
  top: 0;

  min-height: 100vh;
  width: 100%;
  max-width: 100%;

  text-align: start;
  background: ${theme.palette.background.main};
  transform-origin: center center;
  transform-style: preserve-3d;

  @supports (min-height: 100dvh) {
    min-height: 100dvh;
  }

  ${styles.breakpoint.up('sm')} {
    max-width: 560px;
  }
`
